import { render, staticRenderFns } from "./TotpEnrollment.vue?vue&type=template&id=5056aeb2&scoped=true&"
import script from "./TotpEnrollment.vue?vue&type=script&lang=js&"
export * from "./TotpEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./TotpEnrollment.vue?vue&type=style&index=0&id=5056aeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056aeb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VProgressCircular,VTextField})
